<div class="relative flex flex-row items-center gap-12" [ngClass]="data.class">
  <img
    [src]="data.image"
    [alt]="data.label"
    [alt]="'global.line' | translate"
    class="absolute -translate-x-1/2 opacity-15 lg:opacity-100 lg:relative w-60 lg:w-40 left-1/2 lg:left-0 lg:translate-x-0"
  />
  <div class="bg-base-grey h-36 w-0.5 hidden lg:block"></div>
  <div class="flex-col items-center lg:items-start statistic__data">
    <span class="font-bold leading-none statistic__value text-8xl md:text-9xl">{{ data.value }}</span>
    <span class="text-5xl font-normal statistic__label">{{ data.label }}</span>
  </div>
</div>
